module.exports = __webpack_public_path__ + "static/works-trualert-site-89b8f27a230d178d57b880eef97c009f.png";